export default "__VITE_ASSET__1d29cd80__"